import {_get, _post, _put} from "./Axios";

export default class BookingApi {
    static get(id = null, koas_resident_code = null) {
        if (id && koas_resident_code)
            return _get('/booking/booking/detail/' + id + '/' + koas_resident_code)
        else if (id)
            return _get('/booking/booking/detail/' + id)
        else
            return _get('/booking/booking')
    }

    static getByQuery(data= {}) {
        let params = [];

        for (const param in data) {
            params.push(param + '=' + data[param])
        }

        const urlEncodedParams = params.join('&');

        return _get('/booking/booking/by_query?' + urlEncodedParams)
    }

    static getEvaluasi(data= {}) {
        let params = [];

        for (const param in data) {
            params.push(param + '=' + data[param])
        }

        const urlEncodedParams = params.join('&');

        return _get('/booking/booking/evaluation?' + urlEncodedParams)
    }

    static bookDPJP(id, dpjpCode, departmentCode, lateCanceled = false) {
        return _post('/booking/booking/book_dpjp/' + id, {
            dpjp_code: dpjpCode,
            department_code: departmentCode,
            late_canceled: lateCanceled ? 1 : 0
        })
    }

    static cancelDPJP(id, lateCanceled = false) {
        return _post('/booking/booking/cancel_dpjp/' + id, {
            late_canceled: lateCanceled ? 1 : 0
        })
    }

    static accDPJP(id, step, lateCanceled = false, isPartner = false) {
        return _post('/booking/booking/acc_dpjp/' + id + '/' + step, {
            late_canceled: lateCanceled ? 1 : 0,
            is_partner: isPartner ? 1 : 0,
        })
    }

    static cancelApprovalDPJP(id, reason) {
        return _post('/booking/booking/cancel_approval_dpjp/' + id, {
            reason
        })
    }

    static requestCase(id, cases, is_partner, by_not_indicated) {
        return _post('/booking/booking/request_case', {
            id,
            cases,
            is_partner: is_partner ? 1 : 0,
            by_not_indicated: by_not_indicated ? 1 : 0,
        })
    }

    static editCase(id, is_partner, cases) {
        return _post('/booking/booking/edit_case', {
            id,
            is_partner: is_partner ? 1 : 0,
            cases,
        })
    }

    static openWorkingFormat(id) {
        return _post('/booking/booking/open_working_format/' + id, {})
    }

    static requestTreatmentAction(id, is_partner) {
        return _post('/booking/booking/request_treatment_action/' + id, {
            is_partner: is_partner ? 1 : 0
        })
    }

    static reorderBmhp(id, is_partner) {
        return _post('/booking/booking/reorder_bmhp/' + id, {
            is_partner: is_partner ? 1 : 0
        })
    }

    static declineDPJP(id, step, alasan_dpjp_menolak, isPartner = false) {
        return _post('/booking/booking/decline_dpjp/' + id, {
            step,
            alasan_dpjp_menolak,
            is_partner: isPartner ? 1 : 0
        })
    }

    static declineCaseDPJP(id, alasan_dpjp_menolak, isPartner = false) {
        return _post('/booking/booking/decline_case_dpjp/' + id, {
            alasan_dpjp_menolak,
            is_partner: isPartner ? 1 : 0
        })
    }

    static undoStep(id) {
        return _post('/booking/booking/undo_step/' + id, {})
    }

    static prepare(id, is_partner) {
        return _post('/booking/booking/prepare/' + id, {
            is_partner: is_partner ? 1 : 0,
        })
    }

    static delegasi(id, dpjp_code, reason) {
        return _post('/booking/booking/delegasi/' + id, {
            dpjp_code,
            reason
        })
    }

    static joinKoas(id, koas_code) {
        return _post('/booking/booking/join_koas/' + id, {
            koas_code
        })
    }

    static deleteJoinKoas(id) {
        return _post('/booking/booking/delete_join_koas/' + id, {})
    }

    static deleteBooking(booking_code) {
        return _post('/booking/booking/delete/' + booking_code, {})
    }

    static switchKoas(id) {
        return _post('/booking/booking/switch_koas/' + id, {})
    }

    static setStatusManual(id, status) {
        return _post('/booking/booking/status_manual/', {
            id,
            status
        })
    }

    static editBooking(data) {
        return _post('/booking/booking/edit', data)
    }

    static status = []

    static getStatus() {
        if (this.status.length > 0)
            return Promise.resolve(this.status)
        else
            return _get('/masterdata/status')
                .then(r => {
                    this.status = r

                    return r
                })
    }

    static create(data) {
        return _post('/booking/booking/create', data)
    }
}
